import * as React from 'react'
import * as ReactDOM from 'react-dom'

import { OrganisationsApp } from './organisations/OrganisationsApp'
import { OrganisationApp } from './organisations/OrganisationApp'
import { ITrame } from './adhoc/util'
import { ScnGeneral } from './cn-softaccess/components/sncGeneral'
import Facturation from './facturation/facturation'
import { MsBotsGeneral } from './ms-softaccess/components/MsBotsGeneral'
import { LogsGeneral } from './logs/LogsGeneral'
import { ExportsGeneral } from './exports/ExportsGeneral'
import { Login } from './login/Login'
declare var $: any

const loginRoot = document.getElementById('login-root')
if (window.location.pathname === '/login' && loginRoot) {
  ReactDOM.render(<Login />, loginRoot)
}

if (window.location.href.indexOf('/ms/bots') > -1 && $('#msBotsInjectableReact').length > 0) {
  ReactDOM.render(
    <MsBotsGeneral />, document.getElementById('msBotsInjectableReact')
  )

}
else if (window.location.href.indexOf('cnegoces/files') > -1) {
  ReactDOM.render(
    <ScnGeneral />,
    document.getElementById('scngeneral'),
  )
}
else if (window.location.href.indexOf('/facturation') > -1) {
  ReactDOM.render(
    <Facturation />,
    document.getElementById('facturation_inject_react'),
  )

}
else if (window.location.href.indexOf('/logs') > -1 && $('#logsInjectableReact').length > 0) {
  ReactDOM.render(
    <LogsGeneral />, document.getElementById('logsInjectableReact')
  )
} else if (window.location.href.indexOf('/exports') > -1 && $('#exportsInjectableReact').length > 0) {
  ReactDOM.render(
    <ExportsGeneral />, document.getElementById('exportsInjectableReact')
  )
}

const organisationAppRoot = document.getElementById('organisation-app-root')
if (organisationAppRoot) {
  const orgaId = organisationAppRoot.getAttribute('data-orga-id') || ''
  const orgaName = organisationAppRoot.getAttribute('data-orga-name') || ''
  const adhocRaw = organisationAppRoot.getAttribute('data-adhoc') || '[]'
  let adhocData: ITrame[] = []
  try {
    adhocData = JSON.parse(adhocRaw)
  } catch {
    adhocData = []
  }
  ReactDOM.render(
    <OrganisationApp orgaId={orgaId} orgaName={orgaName} adhocData={adhocData} />,
    organisationAppRoot,
  )
}

const organisationsRoot = document.getElementById('organisations-root')
if (organisationsRoot) {
  ReactDOM.render(<OrganisationsApp />, organisationsRoot)
}
